<template>

  <div>
    <div
      class="buymodal-block__body">

      <div
        class="body-form">
        <label
          for="number"
          class="body-form__label">
          Выкуп смарт-часов по серийному номеру<br>Длинна SN Apple 12 символов<br> Длинна SN Samsung 11 символов:
        </label>
        <input
          type="text"
          class="body-form__input"
          placeholder="AABBCC00DD11"
          v-model.trim="number"
          maxlength="12"
          @input="changeLength($event)"
          id="number">
        <div
          class="body-form__size">
          <span
            class="error-mess">
            {{ errorSearch }}
          </span>
          <span
            class="length">
            {{ length }} символов из 11/12 символов
          </span>
        </div>
      </div>

    </div>

    <div
      class="buymodal-block__footer">
      <button
        type="button"
        class="btn next"
        @click.prevent="length > 0? searchModel({ sn: number }) : false">
        Начать выкуп
      </button>
    </div>

  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      number: '',
      length: 0,
    }
  },
  computed: {
    ...mapState('buymodels', ['errorSearch']),
  },
  methods: {
    ...mapActions('buymodels', ['searchModel']),

    changeLength(e) {
      const value = e.target.value.toString();
      this.number = value.toUpperCase();
      this.length = e.target.value.length;
    },
  },
}
</script>

<style lang="css">
</style>
